module.exports = __webpack_public_path__ + "img/report.e20f624a.png";